var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"back",on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._m(0),_c('span',{staticClass:"back__text"},[_vm._v(" "+_vm._s(_vm.$t('COMMON.BACK_BUTTON'))+" ")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"back__icon"},[_c('i',{staticClass:"el-icon-arrow-left"})])
}]

export { render, staticRenderFns }